import { useState } from "react";
import { Button } from "@/components/ui/button";
import { PlusCircle, Users } from "lucide-react";
import { UserProfile } from "@/types/user";
import { CreateGroupChatDialog } from "./CreateGroupChatDialog";
import { useUser } from "@/contexts/UserContext";
import { CreateChatDialog } from "./CreateChatDialog";

type ChatHeaderActionsProps = {
  onCreateGroupChat?: (name: string, members: UserProfile[]) => void;
  onCreateNewChat?: (member: UserProfile) => void;
};

export default function ChatHeaderActions({
  onCreateGroupChat,
  onCreateNewChat,
}: ChatHeaderActionsProps) {
  const [isCreateGroupOpen, setIsCreateGroupOpen] = useState(false);
  const [isCreateChatOpen, setIsCreateChatOpen] = useState(false);
  const { user } = useUser();

  return (
    <div className="flex items-center justify-between mb-3">
      <h2 className="text-lg font-bold">Chats</h2>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          className="h-8 px-2"
          onClick={() => setIsCreateGroupOpen(true)}
        >
          <Users className="h-4 w-4 mr-1" />
          <span className="hidden sm:inline text-xs">New Group</span>
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="h-8 px-2"
          onClick={() => setIsCreateChatOpen(true)}
        >
          <PlusCircle className="h-4 w-4 mr-1" />
          <span className="hidden sm:inline text-xs">New Chat</span>
        </Button>
      </div>

      {onCreateGroupChat && user && (
        <CreateGroupChatDialog
          open={isCreateGroupOpen}
          onOpenChange={setIsCreateGroupOpen}
          onCreateGroup={onCreateGroupChat}
          currentUserId={user.id}
        />
      )}
      {onCreateNewChat && user && (
        <CreateChatDialog
          open={isCreateChatOpen}
          onOpenChange={setIsCreateChatOpen}
          onCreateNewChat={onCreateNewChat}
          currentUserId={user.id}
        />
      )}
    </div>
  );
}
